module.exports = __webpack_public_path__ + "images/category_lp/watch/rolex_samples/pattern_c3/btn_2_sp_4f985f98f91ada04e07b6a5adc8fff7f.png";